import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PickupThingsComponent } from '../../shared/components/pickup-things/pickup-things.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';
import { RequestStatusComponent } from './request-status/request-status.component';
import { RolesApiService, Role } from '@angular-workspace/services';
import { ToasterService } from '../../services/toaster.service';
import { WorkspaceContextService } from '../../services/workspace-context.service';

@Component({
  selector: 'app-consumer-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    RequestStatusComponent,
    PickupThingsComponent,
    ActivitiesComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class ConsumerDashboardComponent implements OnInit {
  private rolesService = inject(RolesApiService);
  private router = inject(Router);
  private toasterService = inject(ToasterService);
  private workspaceContext = inject(WorkspaceContextService);

  canAccess = false;
  isChecking = true;

  async ngOnInit(): Promise<void> {
    await this.checkConsumerRole();
  }

  private async checkConsumerRole(): Promise<void> {
    try {
      try {
        await this.workspaceContext.loadDelegatedWorkspaces();
      } catch {
        /* use whatever workspace cache we already have */
      }

      if (this.workspaceContext.getActiveDelegatedPanelRole() === Role.CONSUMER) {
        this.canAccess = true;
        return;
      }

      await this.rolesService.getRoles();
      const userRoles = this.rolesService.getUserRoles();
      const highestRole = this.rolesService.getHighestRole(userRoles);

      if (highestRole === Role.CONSUMER) {
        this.canAccess = true;
        return;
      }

      if (!highestRole) {
        this.canAccess = true;
        return;
      }

      this.toasterService.warning("You don't have access to some of the panels.");
      this.router.navigate(['/'], { replaceUrl: true });
    } catch (error) {
      console.error('Error checking roles:', error);
      this.canAccess = true;
    } finally {
      this.isChecking = false;
    }
  }
}
